export default __webpack_public_path__ + "static/media/arrow-icon.65820ee9.svg";